var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link)?_c('VBtn',{staticClass:"float-right ml-2",attrs:{"href":_vm.link,"target":"_blank","depressed":"","color":"info lighten-1"}},[_vm._v(" Инструкция ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }